import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class HoverTrackService {
  public hoverTrack: Subject<boolean> = new Subject<boolean>();
  isLoadSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  constructor() {}
}
